import { Box, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import styles from './TldPromotion.scss';
export const TldPromotionSkeleton = _ref => {
  let {
    index
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    key: index,
    padding: "SP2 45px",
    direction: "vertical",
    gap: "SP4",
    minHeight: "205px",
    align: "space-between",
    position: "relative",
    className: styles.gridItem
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "60px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "21px"
  }, /*#__PURE__*/React.createElement(Box, {
    minHeight: "18px"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: styles.skeleton,
    width: "100px",
    height: "18px"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "50px",
    maxWidth: "200px"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: styles.skeleton,
    width: "132px",
    height: "59px"
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: styles.skeleton,
    width: "160px",
    height: "18px"
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP1",
    align: "right"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: styles.skeleton,
    width: "40px",
    height: "18px"
  }))));
};
//# sourceMappingURL=TldPromotionSkeleton.js.map